

















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { GQL_ameldingNewData_currentUnit_subUnits_workRelations, GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding, GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_occupation } from '@/queries/__generated__/ameldingNewData';
import AmeldingFormPaycheck from './AmeldingFormPaycheck.vue';
import AmeldingFormPaycheckHeader from './AmeldingFormPaycheckHeader.vue';
import AmeldingFormWorkRelationLeaveAndLayoffs from './AmeldingFormWorkRelationLeaveAndLayoffs.vue';
import { WithSelectedFlag, WithOverwrite } from './AmeldingForm.vue';
import { GQL_AltinnShiftTypeEnum, GQL_AltinnEmploymentTypeEnum, GQL_AltinnEmploymentDurationTypeEnum, GQL_AltinnEmploymentEndReasonEnum } from '@/queries/global';
import formatPaycheckNumber from '@/filters/formatPaycheckNumber';
import Decimal from '@/utils/decimal';

/* eslint-disable @typescript-eslint/no-explicit-any */
export type PickedWorkRelation = {
  title: string;
  occupation: GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_occupation | null;
  endDate: any;
  samePositionSince: any;
  shiftType: GQL_AltinnShiftTypeEnum | null;
  employmentType: GQL_AltinnEmploymentTypeEnum;
  employmentPercentage: Decimal | null;
  employmentPercentageUpdated: any;
  hoursEveryWeekWithFullEmployment: Decimal | null;
  lastSalaryChange: any;
  durationType: GQL_AltinnEmploymentDurationTypeEnum | null;
  endReason: GQL_AltinnEmploymentEndReasonEnum | null;
};
/* eslint-enable @typescript-eslint/no-explicit-any */

@Component({
  components: {
    AmeldingFormPaycheck,
    AmeldingFormPaycheckHeader,
    AmeldingFormWorkRelationLeaveAndLayoffs,
  },
})
export default class AmeldingFormWorkRelation extends Vue {
  @Prop({ type: Object, required: true }) private workRelation!: WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations> & WithOverwrite<GQL_ameldingNewData_currentUnit_subUnits_workRelations>;

  public mergeResult: PickedWorkRelation | null = null;

  private showBlenderForWorkRelations = false;
  public dataConflictResolved = true;

  @Watch('workRelation.$_selected')
  private unselectPaychecks(): void {
    // unselect paychecks only when work relation is unselected
    if (this.workRelation.$_selected) return;

    (this.workRelation.paychecksForAmelding as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding>[])
      .forEach(p => { p.$_selected = false });
  }

  private removeOwerwriteFromWorkRelation() {
    this.workRelation.overwrite = undefined;
    this.dataConflictResolved = !this.showWarningForDifferentData;
  }

  private selectWorkRelation(): void {
    this.workRelation.$_selected = true;
    this.dataConflictResolved = !this.showWarningForDifferentData;
    this.workRelation.overwrite = undefined;
  }

  private created() {
    // when resending, we want our data in SBlender
    // to be the same as the previous amelding
    this.mergeResult = this.workRelation.overwrite || null;
  }

  private get selectedWorkRelationWithPaycheckWorkRelations(): PickedWorkRelation[] {
    const paychecks: PickedWorkRelation[] = (this.workRelation.paychecksForAmelding as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding>[])
      .filter(p => p.$_selected)
      .map(paycheck => {
        return {
          title: formatPaycheckNumber(String(paycheck.number)) || '',
          occupation: paycheck.occupation,
          endDate: paycheck.workRelationEndDate,
          samePositionSince: paycheck.samePositionSince,
          shiftType: paycheck.shiftType,
          employmentType: paycheck.employmentType,
          employmentPercentage: paycheck.employmentPercentage,
          employmentPercentageUpdated: paycheck.employmentPercentageUpdated,
          hoursEveryWeekWithFullEmployment: paycheck.hoursEveryWeekWithFullEmployment,
          lastSalaryChange: paycheck.lastSalaryChange,
          endReason: paycheck.workRelationEndReason,
          durationType: paycheck.workRelationDurationType,
        };
      });

    return [
      ...paychecks,
      {
        title: `${this.workRelation.employee.firstName} ${this.workRelation.employee.lastName}`,
        occupation: this.workRelation.occupation,
        endDate: this.workRelation.endDate,
        samePositionSince: this.workRelation.samePositionSince,
        shiftType: this.workRelation.shiftType,
        employmentType: this.workRelation.employmentType,
        employmentPercentage: this.workRelation.employmentPercentage,
        employmentPercentageUpdated: this.workRelation.employmentPercentageUpdated,
        hoursEveryWeekWithFullEmployment: this.workRelation.hoursEveryWeekWithFullEmployment,
        lastSalaryChange: this.workRelation.lastSalaryChange,
        durationType: this.workRelation.durationType,
        endReason: this.workRelation.endReason,
      },
    ];
  }

  private useSelectedWorkRelation(): void {
    this.showBlenderForWorkRelations = false;
    if (this.mergeResult) {
      this.workRelation.overwrite = this.mergeResult;
      this.dataConflictResolved = true;
    }
  }

  public get showWarningForDifferentData(): boolean {
    const areSameMaybeDecimal = (d1: Decimal | null, d2: Decimal | null) => {
      if (!d1 && !d2) return true;
      if (d1 && d2) return d1.equals(d2);
      return false;
    };

    return (this.workRelation.paychecksForAmelding as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding>[])
      .filter(p => p.$_selected)
      .some(p => {
        return (
          (this.workRelation.occupation?.id || '') !== (p.occupation?.id || '') ||
          p.workRelationEndDate !== this.workRelation.endDate ||
          p.samePositionSince !== this.workRelation.samePositionSince ||
          p.shiftType !== this.workRelation.shiftType ||
          p.employmentType !== this.workRelation.employmentType ||
          !areSameMaybeDecimal(p.employmentPercentage, this.workRelation.employmentPercentage) ||
          p.employmentPercentageUpdated !== this.workRelation.employmentPercentageUpdated ||
          !areSameMaybeDecimal(p.hoursEveryWeekWithFullEmployment, this.workRelation.hoursEveryWeekWithFullEmployment) ||
          p.lastSalaryChange !== this.workRelation.lastSalaryChange ||
          p.workRelationEndReason !== this.workRelation.endReason ||
          p.workRelationDurationType !== this.workRelation.durationType
        );
      });
  }
}
